import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-invalid-form-modal',
  templateUrl: './invalid-form-modal.component.html',
  styleUrls: ['./invalid-form-modal.component.scss']
})
export class InvalidFormModalComponent implements OnInit {

  list: any[] = [];
  listString: any[] = [];
  stringItems: string = '';

  constructor(private dialogRef: MatDialogRef<InvalidFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.list = this.data;
    this.listString = this.data;
    this.listString.forEach((item: any, index: number) => {
      if (index === this.listString.length - 1) {
        this.stringItems += item;
      } else {
        this.stringItems += item + ' | ';
      }
      
    });
  }

  closeDialog() {
    this.dialogRef.close(this.list[0]);
  }

}
